/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AccountId,
  ApplicationRegistrationCommentRequest,
  ApplicationRegistrationId,
  ApplicationRegistrationRequest,
  ApplicationRegistrationWithoutFilterUnitResponse,
  ApplicationRegistrationsResponse,
  HttpValidationProblemDetails,
  ListApplicationRegistrationsGroupedParams,
  ListApplicationRegistrationsWithoutFilterUnitParams,
  RegistrationCompositeId,
  SegmentationId
} from './data.schemas'




export const listApplicationRegistrationsGrouped = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsGroupedParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApplicationRegistrationsResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getListApplicationRegistrationsGroupedQueryKey = (segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsGroupedParams,) => {
    return [`/api/segment/${segmentationId}/customers/${accountId}/registrationComposites/applications`, ...(params ? [params]: [])] as const;
    }

    
export const getListApplicationRegistrationsGroupedQueryOptions = <TData = Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>, TError = AxiosError<unknown>>(segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsGroupedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApplicationRegistrationsGroupedQueryKey(segmentationId,accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>> = ({ signal }) => listApplicationRegistrationsGrouped(segmentationId,accountId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && accountId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApplicationRegistrationsGroupedQueryResult = NonNullable<Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>>
export type ListApplicationRegistrationsGroupedQueryError = AxiosError<unknown>

export const useListApplicationRegistrationsGrouped = <TData = Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>, TError = AxiosError<unknown>>(
 segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsGroupedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListApplicationRegistrationsGroupedQueryOptions(segmentationId,accountId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchListApplicationRegistrationsGrouped = async <TData = Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>, TError = AxiosError<unknown>>(
 queryClient: QueryClient, segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsGroupedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationsGrouped>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getListApplicationRegistrationsGroupedQueryOptions(segmentationId,accountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const createCompositeWithApplicationRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    applicationRegistrationRequest: ApplicationRegistrationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RegistrationCompositeId>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/applications`,
      applicationRegistrationRequest,options
    );
  }



export const getCreateCompositeWithApplicationRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: ApplicationRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: ApplicationRegistrationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompositeWithApplicationRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;data: ApplicationRegistrationRequest}> = (props) => {
          const {segmentationId,accountId,data} = props ?? {};

          return  createCompositeWithApplicationRegistration(segmentationId,accountId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompositeWithApplicationRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof createCompositeWithApplicationRegistration>>>
    export type CreateCompositeWithApplicationRegistrationMutationBody = ApplicationRegistrationRequest
    export type CreateCompositeWithApplicationRegistrationMutationError = AxiosError<HttpValidationProblemDetails>

    export const useCreateCompositeWithApplicationRegistration = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: ApplicationRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createCompositeWithApplicationRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;data: ApplicationRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getCreateCompositeWithApplicationRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const listApplicationRegistrationGroups = (
    segmentationId: SegmentationId,
    accountId: AccountId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/applications/groups`,options
    );
  }


export const getListApplicationRegistrationGroupsQueryKey = (segmentationId: SegmentationId,
    accountId: AccountId,) => {
    return [`/api/segment/${segmentationId}/customers/${accountId}/registrationComposites/applications/groups`] as const;
    }

    
export const getListApplicationRegistrationGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listApplicationRegistrationGroups>>, TError = AxiosError<unknown>>(segmentationId: SegmentationId,
    accountId: AccountId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApplicationRegistrationGroupsQueryKey(segmentationId,accountId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApplicationRegistrationGroups>>> = ({ signal }) => listApplicationRegistrationGroups(segmentationId,accountId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApplicationRegistrationGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listApplicationRegistrationGroups>>>
export type ListApplicationRegistrationGroupsQueryError = AxiosError<unknown>

export const useListApplicationRegistrationGroups = <TData = Awaited<ReturnType<typeof listApplicationRegistrationGroups>>, TError = AxiosError<unknown>>(
 segmentationId: SegmentationId,
    accountId: AccountId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationGroups>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListApplicationRegistrationGroupsQueryOptions(segmentationId,accountId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const listApplicationRegistrationsWithoutFilterUnit = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsWithoutFilterUnitParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApplicationRegistrationWithoutFilterUnitResponse[]>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/applications/without-filter-unit`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getListApplicationRegistrationsWithoutFilterUnitQueryKey = (segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsWithoutFilterUnitParams,) => {
    return [`/api/segment/${segmentationId}/customers/${accountId}/registrationComposites/applications/without-filter-unit`, ...(params ? [params]: [])] as const;
    }

    
export const getListApplicationRegistrationsWithoutFilterUnitQueryOptions = <TData = Awaited<ReturnType<typeof listApplicationRegistrationsWithoutFilterUnit>>, TError = AxiosError<unknown>>(segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsWithoutFilterUnitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationsWithoutFilterUnit>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApplicationRegistrationsWithoutFilterUnitQueryKey(segmentationId,accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApplicationRegistrationsWithoutFilterUnit>>> = ({ signal }) => listApplicationRegistrationsWithoutFilterUnit(segmentationId,accountId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationsWithoutFilterUnit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApplicationRegistrationsWithoutFilterUnitQueryResult = NonNullable<Awaited<ReturnType<typeof listApplicationRegistrationsWithoutFilterUnit>>>
export type ListApplicationRegistrationsWithoutFilterUnitQueryError = AxiosError<unknown>

export const useListApplicationRegistrationsWithoutFilterUnit = <TData = Awaited<ReturnType<typeof listApplicationRegistrationsWithoutFilterUnit>>, TError = AxiosError<unknown>>(
 segmentationId: SegmentationId,
    accountId: AccountId,
    params?: ListApplicationRegistrationsWithoutFilterUnitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationRegistrationsWithoutFilterUnit>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListApplicationRegistrationsWithoutFilterUnitQueryOptions(segmentationId,accountId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateApplicationRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    applicationId: ApplicationRegistrationId,
    applicationRegistrationRequest: ApplicationRegistrationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.put(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/applications/${encodeURIComponent(String(applicationId))}`,
      applicationRegistrationRequest,options
    );
  }



export const getUpdateApplicationRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApplicationRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,applicationId,data} = props ?? {};

          return  updateApplicationRegistration(segmentationId,accountId,registrationCompositeId,applicationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateApplicationRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateApplicationRegistration>>>
    export type UpdateApplicationRegistrationMutationBody = ApplicationRegistrationRequest
    export type UpdateApplicationRegistrationMutationError = AxiosError<HttpValidationProblemDetails>

    export const useUpdateApplicationRegistration = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateApplicationRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getUpdateApplicationRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteApplicationRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    applicationId: ApplicationRegistrationId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/applications/${encodeURIComponent(String(applicationId))}`,options
    );
  }



export const getDeleteApplicationRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApplicationRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,applicationId} = props ?? {};

          return  deleteApplicationRegistration(segmentationId,accountId,registrationCompositeId,applicationId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApplicationRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApplicationRegistration>>>
    
    export type DeleteApplicationRegistrationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useDeleteApplicationRegistration = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApplicationRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId},
        TContext
      > => {

      const mutationOptions = getDeleteApplicationRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const addComment = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    applicationId: ApplicationRegistrationId,
    applicationRegistrationCommentRequest: ApplicationRegistrationCommentRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/applications/${encodeURIComponent(String(applicationId))}/comments`,
      applicationRegistrationCommentRequest,options
    );
  }



export const getAddCommentMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addComment>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationCommentRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addComment>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationCommentRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addComment>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationCommentRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,applicationId,data} = props ?? {};

          return  addComment(segmentationId,accountId,registrationCompositeId,applicationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addComment>>>
    export type AddCommentMutationBody = ApplicationRegistrationCommentRequest
    export type AddCommentMutationError = AxiosError<HttpValidationProblemDetails>

    export const useAddComment = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addComment>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationCommentRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addComment>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;applicationId: ApplicationRegistrationId;data: ApplicationRegistrationCommentRequest},
        TContext
      > => {

      const mutationOptions = getAddCommentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const createApplicationRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    applicationRegistrationRequest: ApplicationRegistrationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApplicationRegistrationId>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/applications`,
      applicationRegistrationRequest,options
    );
  }



export const getCreateApplicationRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: ApplicationRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: ApplicationRegistrationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApplicationRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: ApplicationRegistrationRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,data} = props ?? {};

          return  createApplicationRegistration(segmentationId,accountId,registrationCompositeId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateApplicationRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof createApplicationRegistration>>>
    export type CreateApplicationRegistrationMutationBody = ApplicationRegistrationRequest
    export type CreateApplicationRegistrationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useCreateApplicationRegistration = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApplicationRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: ApplicationRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createApplicationRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: ApplicationRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getCreateApplicationRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    